import { useMemo, type FC } from 'react'
import { getUseConfigStore } from '../stores/useConfigStore'
import { AsyncButton, Separator } from '@bpinternal/ui-kit-next'
import { AboutSection } from './sections/About'
import { ContactSection } from './sections/Contact'
import { SettingsSection } from './sections/Settings'
import { generateThemeOverride } from '@botpress/webchat'
import { useLocalStore } from '~/stores'
import { ProactiveBubbleSection } from './sections/ProactiveBubble'
import { useFeature } from '../../../hooks'
import { Paywall } from '../../../components'
import { Plan } from '~/features/billing/types'

type Props = {
  workspaceId: string
  botId: string
  plan: Plan
}

export const GeneralConfig: FC<Props> = ({ workspaceId, botId, plan }) => {
  const useConfigStore = useMemo(() => getUseConfigStore({ botId, workspaceId }), [botId, workspaceId])

  const color = useConfigStore((state) => state.color)
  const saveConfig = useConfigStore((state) => state.saveConfig)
  const _updating = useConfigStore((state) => state._updating)
  const proactiveEnabled = useFeature('proactiveBubble')

  const dashboardTheme = useLocalStore((state) => state.getPreferredTheme())
  const webchatPreviewStyle = generateThemeOverride({ themeMode: dashboardTheme, color })

  return (
    <div className="flex flex-col gap-6">
      <AboutSection workspaceId={workspaceId} botId={botId} plan={plan} />
      <Separator />
      <div style={webchatPreviewStyle}>
        <SettingsSection workspaceId={workspaceId} botId={botId} />
      </div>
      <Separator />
      {proactiveEnabled && (
        <Paywall minimumPlan="plus" analyticsEventName="proactive_message">
          <div style={webchatPreviewStyle}>
            <ProactiveBubbleSection botId={botId} workspaceId={workspaceId} />
          </div>
        </Paywall>
      )}
      <Separator />
      <ContactSection workspaceId={workspaceId} botId={botId} />
      <AsyncButton loading={_updating} className="self-end" onClick={saveConfig}>
        Save Configuration
      </AsyncButton>
    </div>
  )
}
